import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../routes'
import {
  CONSENT_DOCUMENT_DATE_LABEL,
  CONSENT_SECTIONS,
  CONSENT_SUBTITLE,
  CONSENT_TITLE
} from '../consentDocument'
import '../styles/consent-document.css'

// Публичная страница документа. Открывается без входа новой вкладкой из
// формы регистрации и экрана согласия, в том числе из слайдера Bitrix24 и
// iframe amoCRM. Только страница: скачивания нет по решению владельца.
export default function ConsentDocumentPage () {
  return (
    <div className='consent-doc'>
      <div className='consent-doc__head'>
        <Link to='/' className='consent-doc__brand' aria-label='Платформа интеграций Финтабло'>
          <img src='/fintablo-platform-logo.png' alt='Финтабло — платформа интеграций' />
        </Link>
        <Link to={ROUTES.LOGIN} className='consent-doc__back'>← Ко входу</Link>
      </div>

      <article className='consent-doc__body'>
        <h1 className='consent-doc__title'>{CONSENT_TITLE}</h1>
        <p className='consent-doc__subtitle'>
          {CONSENT_SUBTITLE[0]}
          <br />
          {CONSENT_SUBTITLE[1]}
        </p>
        <div className='consent-doc__meta'>
          <span>Дата документа: <b>{CONSENT_DOCUMENT_DATE_LABEL}</b></span>
          <span>Оператор: <b>ООО «НФ Софт»</b></span>
        </div>

        {CONSENT_SECTIONS.map(section => (
          <section key={section.number} className='consent-doc__section'>
            <h2>
              <span className='consent-doc__num'>{section.number}</span>
              {section.title}
            </h2>
            {section.blocks.map((block, index) => block.type === 'list'
              ? (
                <ul key={index}>
                  {block.items.map(item => <li key={item}>{item}</li>)}
                </ul>
                )
              : <p key={index}>{block.text}</p>
            )}
          </section>
        ))}
      </article>

      <div className='consent-doc__foot'>
        <span>ООО «НФ Софт», ИНН 2311303019</span>
        <a href='mailto:support@help.fintablo.ru'>support@help.fintablo.ru</a>
      </div>
    </div>
  )
}
